export default __webpack_public_path__ + "static/media/close.571bbd38.svg";